import React, { useState } from 'react';
import './PriceCompare.scss';
import RecentSearch from './recent-search/RecentSearch';
import PriceCompareSearch from './PriceCompareSearch';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getFamilyList } from '../../utils/Coverage';
import { ToastContainer } from 'react-toastify';

const PriceCompare = () => {
  const { searchParamsForUI, searchProviderParams, networksList } = useSelector(
    (state) => state.priceCompare,
  );
  const {
    loggedInUserOID,
    loggedInMemberType,
    employeeInfo,
    dependentsInfo,
    contactDetails,
  } = useSelector((state) => state.memberSummary);
  const procedureForInfo = getFamilyList(
    employeeInfo,
    dependentsInfo,
    loggedInMemberType,
    loggedInUserOID,
  );
  const procedureForOptionList = procedureForInfo?.filter(
    (item) => !item?.value?.includes('Family'),
  );
  const procedureForDefaultSelected =
    procedureForOptionList?.filter(
      (item) => item?.value === loggedInUserOID,
    )[0] || {};
  const [procedureForDataParent, setProcedureForDataParent] = useState(
    searchParamsForUI?.procedureForData
      ? searchParamsForUI?.procedureForData
      : procedureForDefaultSelected,
  );

  return (
    <Container className="price-comparison-container p-0">
      <div className="px-0">
        <PriceCompareSearch
          label="search"
          setProcedureForDataParent={setProcedureForDataParent}
        />
        {procedureForDataParent && (
          <div className="recent-search-container">
            <RecentSearch
              showingResultItem={5}
              member={procedureForDataParent}
            />
          </div>
        )}
      </div>
      {/*<div className="toastify">
        <ToastContainer
          draggable
          pauseOnHover
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          autoClose={5000}
          position="top-center"
          newestOnTop={false}
          hideProgressBar={false}
          className="toastcontainer"
        />
      </div> */}
    </Container>
  );
};

export default PriceCompare;
